import React from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PropTypes from "prop-types"
import Cookies from 'universal-cookie';
import axios from "axios";


const cookies = new Cookies();
var intervalId;

class ConfigModal extends React.Component {
  state = {
    show: this.props.show,
    has_service_time_measurements: this.props.has_service_time_measurements
  }

  componentDidMount() {
    var configModalShowCookie = cookies.getAll()['ConfigModalShow']
    if (configModalShowCookie != 'false') {
      intervalId = setInterval(() => {
        if (this.props.show){
          this.checkMeasurements();
        }
      }, 10000);
    } else {
      this.setState({
        show: false,
      });
    }
  }

  componentWillUnmount(){
    if (!typeof(intervalId) == 'undefined'){
      clearInterval(intervalId);
    }
  }

  checkMeasurements = () => {
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    const getMeasurementCount = async () => {
      const response = await axios.get(
        `/measurement_count`,
        { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
      )

      var configModalShowCookie = cookies.getAll()['ConfigModalShow']
        
      this.setState({
        show: response.data.count == 0 && configModalShowCookie != 'false',
        has_service_time_measurements: response.data.service_time_count > 0
      });

      if (!(response.data.count == 0 && configModalShowCookie != 'false')){
        clearInterval(intervalId)
      }
    }
    getMeasurementCount();
  }

  onCloseModal = () => {
    this.setState({
      show: false
    });
    cookies.set('ConfigModalShow', false, { expires: 0, path: '/'});
  }

  modalCopy = () => {
    if (this.state.has_service_time_measurements){
      return `Dynoscale is currently running on ${this.props.application} in service time mode. This means that Dynoscale can scale your web dynos using service time as reported by Heroku. This generally works well but it would be ideal if you switched to queue time mode. Benefits include more accurating scaling and the ability to scale worker dynos.`
    } else {
      return `Before we can activate autoscale rules, we need to make sure ${this.props.application} is shipping queuing data to Dynoscale servers.`
    }
  }

  render () {
    return (
      <React.Fragment>
        <div className="toast-div" style={{position: "fixed", bottom: "1rem", right: "1rem", display: this.state.show ? '': 'none'}}>
            <div className="toast show" id="missingDataToast" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false">
                <div className="toast-header">
                    <span className="mr-auto" style={{margin:"0 0.3rem 0 0.3rem"}}>Missing {this.props.application} Data</span>
                    <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}></button>
                </div>
                <div className="toast-body">
                    <Container>
                      <Row>
                        <Col xs={12} md={4}>
                          <div className="loading-wrapper">
                            <div className="loading-devover">
                            </div>
                            <div className="img">
                              <img src={`${this.props.image_url}`} style={{ width: "100%" }} alt="" srcSet=""/>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} md={8}>
                          <p>{this.modalCopy()}</p>
                          <p>Getting started is easy, follow one of our Guides depending on your application's technology:</p>
                          <ul>
                            <li><a target="_blank" href="/documentation/getting-started-ruby-rails">Ruby/Rails</a></li>
                            <li><a target="_blank" href="/documentation/getting-started-python">Python/Django</a></li>
                            <li><a target="_blank" href="/documentation/getting-started-node">Node</a></li>
                          </ul>
                        </Col>
                      </Row>
                    </Container>
                </div>
            </div>
        </div>
      </React.Fragment>
    );
  }
}

ConfigModal.propTypes = {
  application: PropTypes.string,
  has_service_time_measurements: PropTypes.bool,
  image_url: PropTypes.string,
  show: PropTypes.bool
};

export default ConfigModal
